module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgc3Ryb2tlLXdpZHRoPSIxcHQiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cGF0aCBmaWxsPSIjZmYzMzE5IiBkPSJNMjEzLjMzIDBINjQwdjI0MEgyMTMuMzN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDBjYzI4IiBkPSJNMjEzLjMzIDI0MEg2NDB2MjQwSDIxMy4zM3oiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjEzLjMzdjQ4MEgweiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mg.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mg.svg
// module chunks = 0